
        <form *ngIf="mainForm" [formGroup]="mainForm">
            <div class="row">

                <div class="col-lg-12">
                  <div class="card card-primary">
                    <div class="card-header text-uppercase"> {{title}} </div>
                    <div class="card-body">


            <!-- <label>Notes: </label>
            <input formControlName="Caption" /><br> -->


          <div formArrayName="ApplicantItems">
            <div *ngFor="let appItem of getApplicantItemsArray(mainForm); let i=index; let last = last">
              <div formGroupName="{{i}}">




              <div class="tile">
                  <div class="tile-title-w-btn text-primary">
                    <h6 class="title text-uppercase">{{i+1}}. JOURNAL / CONFERENCE</h6>
                    <div class="btn-group">
                      <button *ngIf="last" class="btn btn-primary"
                       (click)="onAddItemClick()"><i class="fa fa-lg fa-plus"></i>Add
                        New</button>
                      <button class="btn btn-primary" [disabled]="!appItem.valid" (click)="onSaveItemClick(appItem,i)"><i class="fa fa-lg fa-save"></i>Save</button>
                      <button class="btn btn-primary"  (click)="onRemoveItemClick(i)"><i
                          class="fa fa-lg fa-trash"></i>Remove</button>
                    </div>
                  </div>
                  <div class="tile-body">



            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Name of Author(s) <small class="text-muted">(required)</small> </label>
                  <input type="text" formControlName="NameOfAuthors"  class="form-control">

                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>
                    Journal Name <small class="text-muted">(required)</small>
                  </label>
                  <input type="text" formControlName="JournalName"  class="form-control">

                </div>
              </div>
            </div>




            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label> Title of Paper <small class="text-muted">(required)</small> </label>
                  <input type="text" formControlName="TitleOfPaper"  class="form-control">

                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>
                    Date Of Publication <small class="text-muted">(required)</small>
                  </label>
                  <input type="date"  formControlName= "DateOfPublication" class="form-control">

                </div>
              </div>
            </div>



            <div class="row">
              <div class="col-md-6">
                  <div class="form-group">
                      <label class="control-label">Please attach pdf evidence of publication </label>
                      <input formControlName= "FileAttachedName" class="form-control" type="file">
                    </div>

              </div>

              <div class="col-md-6">

              </div>
            </div>







                  </div>
                </div>

              </div>
            </div>

            <div class="form-group">
                <button type="button" (click)="onAddItemClick()"
                 class="btn btn-primary btn-block waves-effect waves-light m-1">
                  <i class="icon-magnifier-add"></i> Add New Journal / Conference
                </button>
              </div>


          </div>




          </div>


          <div class="form-footer">
            <div class="form-group text-center">
              <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious(mainForm)"><i
                  class="fa fa-backward"></i> Go Back</button>

              <button class="btn btn-primary waves-effect waves-light m-1" id="next" [disabled]="!isFormValid()"
                (click)="goToNext(mainForm)">Save &amp; Continue</button>
            </div>
          </div>
          </div>
          </div>

          </div>

          </form>


          <!-- <pre>{{ mainForm.value | json }}</pre> -->




